import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { HEADER_CELL_HEIGHT, TEXT_ALIGN, DATA_CELL_HEIGHT, TABLE_SIZES } from './Table.constants.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var getHighlightStyles = function getHighlightStyles(theme) {
  return "\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ".concat(theme.applyOpacity(theme.colours["interface"].main, 'highlight'), ";\n");
};
var getStickyColumnStyles = function getStickyColumnStyles(theme, $stickyColumns, index, colIndex) {
  return !$stickyColumns[index + 1] || $stickyColumns[index + 1].index !== colIndex + 1 ? "\n      box-shadow:\n        ".concat(theme.sizing.tiny, " ").concat(theme.sizing.xtiny, " 0.3125rem 0 rgb(0 0 0 / 35%);\n      border-right: ").concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.secondary.main, ";\n    ") : '';
};
var StyledTable = styled.table(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: 100%;\n  border-spacing: 0;\n  border-collapse: separate;\n  font-variant-numeric: tabular-nums;\n  ", "\n  tr {\n    ", "\n  }\n\n  tbody {\n    tr:nth-of-type(odd) td {\n      background-color: ", ";\n    }\n\n    tr:nth-of-type(even) td {\n      background-color: ", ";\n    }\n\n    tr {\n      ", "\n    }\n\n    ", "\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colours.canvas.secondary.main;
}, function (_ref2) {
  var theme = _ref2.theme,
    $withBorder = _ref2.$withBorder;
  return $withBorder && "border: ".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.primary.main, ";");
}, function (_ref3) {
  var $stickyColumns = _ref3.$stickyColumns,
    $highlightedColumn = _ref3.$highlightedColumn,
    theme = _ref3.theme;
  return "\n      th:nth-of-type(".concat($highlightedColumn, "), td:nth-of-type(").concat($highlightedColumn, ") {\n        // avoid overriding the 'th' sticky position if the highlighted column is also sticky\n        ").concat($stickyColumns.some(function (col) {
    return col.index === $highlightedColumn;
  }) ? '' : 'position: relative;', "\n\n        button {\n          &::after {\n            pointer-events: none;\n            ").concat(getHighlightStyles(theme), "\n          }\n        }\n      }\n    ");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colours.canvas.secondary.main;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colours.canvas.tertiary.main;
}, function (_ref6) {
  var $stickyColumns = _ref6.$stickyColumns,
    $highlightedColumn = _ref6.$highlightedColumn,
    theme = _ref6.theme;
  return "\n        td:nth-of-type(".concat($highlightedColumn, ") {\n          ").concat($stickyColumns.some(function (col) {
    return col.index === $highlightedColumn;
  }) ? '' : 'position: relative;', "\n\n          &::after {\n            pointer-events: none;\n            ").concat(getHighlightStyles(theme), "\n          }\n        }\n      ");
}, function (_ref7) {
  var $selectedRows = _ref7.$selectedRows,
    theme = _ref7.theme;
  return $selectedRows.map(function (row) {
    return "\n          tr:nth-of-type(".concat(row, ") {\n            position: relative;\n\n            &::after {\n              pointer-events: none;\n              ").concat(getHighlightStyles(theme), "\n            }\n\n            td {\n              border-top: ", "".concat(theme.sizing.xxtiny, " solid ").concat(!$selectedRows.some(function (r) {
      return r === row - 1;
    }) ? theme.colours["interface"].main : 'transparent'), ";\n              border-bottom: ", "".concat(theme.sizing.xxtiny, " solid ").concat(!$selectedRows.some(function (r) {
      return r === row + 1;
    }) ? theme.colours["interface"].main : 'transparent'), ";\n            }\n          }\n      ");
  });
}, function (_ref8) {
  var $isHeadSticky = _ref8.$isHeadSticky,
    theme = _ref8.theme;
  return $isHeadSticky && "\n      thead {\n        box-shadow: ".concat(theme.effects.dropShadow.stickyRow, ";\n        position: sticky;\n        top: 0;\n        z-index: 10;\n      }\n    ");
}, function (_ref9) {
  var $isFootSticky = _ref9.$isFootSticky,
    theme = _ref9.theme;
  return $isFootSticky && "\n      tfoot {\n        box-shadow: ".concat(theme.effects.dropShadow.stickyFooter, ";\n        position: sticky;\n        bottom: 0;\n        z-index: 10;\n      }\n    ");
}, function (_ref10) {
  var $stickyColumns = _ref10.$stickyColumns,
    theme = _ref10.theme;
  return $stickyColumns.map(function (_ref11, index) {
    var width = _ref11.width,
      leftOffset = _ref11.leftOffset,
      colIndex = _ref11.index;
    return "\n        td:nth-of-type(".concat(colIndex, ") {\n          position: sticky;\n          min-width: ").concat(width ? "".concat(width, "rem") : '100%', ";\n          max-width: ").concat(width ? "".concat(width, "rem") : '100%', ";\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          left: ").concat(leftOffset, "rem;\n\n          // In the case of consecutive sticky columns we only want to apply box shadow and border\n          // only to the far right column of that group\n          ").concat(getStickyColumnStyles(theme, $stickyColumns, index, colIndex), "\n          clip-path: inset(0 -0.9375rem -").concat(theme.sizing.small, " 0);\n          z-index: ").concat($stickyColumns.length - index, ";\n        }\n\n        th:nth-of-type(").concat(colIndex, ") {\n          position: sticky;\n          min-width: ").concat(width ? "".concat(width, "rem") : '100%', ";\n          max-width: ").concat(width ? "".concat(width, "rem") : '100%', ";\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          left: ").concat(leftOffset, "rem;\n          ").concat(getStickyColumnStyles(theme, $stickyColumns, index, colIndex), "\n          clip-path: inset(0 -0.9375rem 0 0);\n          z-index: ").concat(2 + $stickyColumns.length - index, ";\n        };\n\n        // cuts off the visible box shadow under the bottom row of the table\n        tr:last-of-type {\n          td:nth-of-type(").concat(colIndex, ") {\n            clip-path: inset(0 -0.9375rem 0 0);\n          }\n        };\n        ");
  });
});
var TableHead = styled.thead(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var TableBody = styled.tbody(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
var TableFoot = styled.tfoot(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  tr {\n    &:first-of-type td {\n      border-top: ", ";\n    }\n\n    td {\n      color: ", ";\n      background-color: ", ";\n      ", "\n    }\n  }\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return "".concat(theme.sizing.xtiny, " solid ").concat(theme.colours["interface"].main);
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colours.ink.primary.main;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colours.canvas.tertiary.main;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.headingSmall;
});
var TableRow = styled.tr(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));
var TableHeaderCellStyled = styled.th(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  height: ", "rem;\n  background-color: ", ";\n  color: ", ";\n  ", "\n  ", "\n  text-align: ", ";\n  border-bottom: ", ";\n  white-space: nowrap;\n  padding: ", ";\n"])), function (_ref16) {
  var $size = _ref16.$size;
  return HEADER_CELL_HEIGHT[$size];
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colours.canvas.tertiary.main;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.applyOpacity(theme.colours.ink.primary.main, 'secondary');
}, function (_ref19) {
  var theme = _ref19.theme,
    $isSortable = _ref19.$isSortable;
  return $isSortable && "\n    &:hover {\n      background-color: ".concat(theme.colours.canvas.tertiary.strong, ";\n      color: ").concat(theme.colours.ink.primary.main, ";\n    }\n  ");
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.typography.headingSmall;
}, function (_ref21) {
  var $textAlign = _ref21.$textAlign;
  return $textAlign;
}, function (_ref22) {
  var theme = _ref22.theme;
  return "".concat(theme.sizing.xtiny, " solid ").concat(theme.colours["interface"].main);
}, function (_ref23) {
  var theme = _ref23.theme,
    $isSortable = _ref23.$isSortable;
  return $isSortable ? 0 : "0 ".concat(theme.sizing.small);
});
var TableHeaderCellButtonStyled = styled.button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  text-align: ", ";\n  white-space: nowrap;\n  padding-block: 0;\n  padding-inline: ", ";\n  width: 100%;\n  height: 100%;\n\n  svg {\n    margin-left: -", ";\n  }\n"])), function (_ref24) {
  var $textAlign = _ref24.$textAlign;
  return $textAlign === TEXT_ALIGN.RIGHT ? 'flex-end' : 'initial';
}, function (_ref25) {
  var $textAlign = _ref25.$textAlign;
  return $textAlign;
}, function (_ref26) {
  var theme = _ref26.theme;
  return "".concat(theme.sizing.tiny, " ").concat(theme.sizing.small);
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.sizing.xtiny;
});
var TableDataCell = styled.td(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  height: ", "rem;\n  text-align: ", ";\n  padding-block: 0;\n  padding-inline: ", ";\n  white-space: nowrap;\n  ", "\n  color: ", ";\n"])), function (_ref28) {
  var $size = _ref28.$size;
  return $size ? DATA_CELL_HEIGHT[$size] : DATA_CELL_HEIGHT[TABLE_SIZES.SMALL];
}, function (_ref29) {
  var $textAlign = _ref29.$textAlign;
  return $textAlign || TEXT_ALIGN.CENTER;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.sizing.small;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.typography.bodyMedium;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.colours.ink.primary.main;
});

export { StyledTable, TableBody, TableDataCell, TableFoot, TableHead, TableHeaderCellButtonStyled, TableHeaderCellStyled, TableRow };
//# sourceMappingURL=Table.styles.js.map
